import Analytics from '../view/Analytics'
export const routes = [
  {
    path: '/analytics',
    name: 'Analytics',
    component: Analytics
  },

]